import { createReducer, on } from '@ngrx/store';
import { stationFollowerActions } from './station-follower.actions';
import { UserSummary } from 'src/swagger-gen/web-secured/models/user-summary';
import { StoreState } from '../../models/store/store-state.models';

export const stationFollowerFeatureKey = 'StationFollowers';

export type FollowersSummaryMap =   Map<string, Array<UserSummary>>;

export type StationFollowerState =  StoreState<FollowersSummaryMap>;

const initialState: StationFollowerState = {
    loading: true,
};

export const stationFollowerReducer = createReducer<StationFollowerState>(
    initialState,
    on(
        stationFollowerActions.fetchSuccess,
        (_, { data }): StationFollowerState => ({
            data,
            loading: false,
            hasError: false
        })
    ),
    on(stationFollowerActions.searchByStations,
        (): StationFollowerState => ({
            loading: true,
        })
    ),
    on(stationFollowerActions.fetchFailure,
        (_, {message}): StationFollowerState => ({
            loading: false,
            hasError: true,
            errorMessage: message,
        })
    )
);
